
var autocomplete;

export const getPredictions = (params) => {
    const { inputId, callback } = params;
    const options = {
        components: 'country:fr',
    };

    // Initialize Google Autocomplete 
    autocomplete = new window.google.maps.places.Autocomplete(
        document.getElementById(inputId), options);

    // Kepp only needed fields because extra data = extra charges
    autocomplete.setFields(['place_id', 'formatted_address']);

    // Fire Event when a suggested name is selected
    autocomplete.addListener('place_changed', () => selectPrediction({ callback }));

    return autocomplete;
};

const selectPrediction = ({ callback }) => {

    // Extract City From Address Object
    const addressObject = autocomplete.getPlace();

    let div = document.createElement("div");
    var service = new window.google.maps.places.PlacesService(div);
    service.getDetails({ placeId: addressObject.place_id }, function (PlaceResult, PlacesServiceStatus) {
        const { geometry, address_components } = PlaceResult;

        const locationInfo = extractAddressComponents(address_components);
        
        callback({
            address: addressObject.formatted_address,
            latitude: geometry.location.lat().toString(),
            longitude: geometry.location.lng().toString(),
            city: locationInfo.city,
            region: locationInfo.region,
            department: locationInfo.department
        });
    });
};

const extractAddressComponents = (address_components) => {
    const LOCATION_CITY = 'locality';
    const LOCATION_DEPARTMENT = 'administrative_area_level_2';
    const LOCATION_REGION = 'administrative_area_level_1';

    let locationInfo = { region: "", department: "", city: "" };

    address_components = address_components.filter(item =>
        item.types.includes(LOCATION_CITY) || item.types.includes(LOCATION_DEPARTMENT) || item.types.includes(LOCATION_REGION));

    address_components = address_components.forEach(item => {
        if (item.types.includes(LOCATION_CITY)) locationInfo.city = item.short_name;
        else if (item.types.includes(LOCATION_DEPARTMENT)) locationInfo.department = item.short_name;
        else if (item.types.includes(LOCATION_REGION)) locationInfo.region = item.short_name;
    });

    return locationInfo;
};